import { j as s } from "../../jsx-runtime-82a9ddf6.js";
import { cn as i } from "../../lib/cn.js";
const d = ({
  width: e = 64,
  height: t = 64,
  className: r
}) => {
  const o = i("animate-spin stroke-[#E9EDF0] dark:stroke-slate-700", r);
  return /* @__PURE__ */ s.jsx("svg", { width: e, height: t, className: o, viewBox: "0 0 70 70", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s.jsxs("g", { id: "Loader", children: [
    /* @__PURE__ */ s.jsx("path", { id: "Ellipse 436", d: "M67 35C67 44.1514 63.1585 52.4056 57 58.238C51.2653 63.669 43.5217 67 35 67C17.3269 67 3 52.6731 3 35C3 17.3269 17.3269 3 35 3C52.6731 3 67 17.3269 67 35Z", strokeWidth: "6" }),
    /* @__PURE__ */ s.jsx("path", { id: "Ellipse 437", d: "M35 3C52.6731 3 67 17.3269 67 35C67 44.1514 63.1585 52.4056 57 58.238", stroke: "#6A3CE2", strokeWidth: "6", strokeLinecap: "round" })
  ] }) });
};
export {
  d as Loader
};
